import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LayoutDashboard } from 'lucide-react-native';
import { ReactNode, memo } from 'react';
import { BiSurfaceCard } from '../components/ui/BiSurfaceCard';

/** A dashboard without cards: how to fill it. */
export const DashboardEmpty = memo(({ action }: { action?: ReactNode }) => {
  const { rpx } = useResponsiveContext();
  return (
    <BiSurfaceCard
      style={{ padding: rpx(24), alignItems: 'center', gap: rpx(8) }}
    >
      <LayoutDashboard size={28} color={aiColors.amber} />
      <Typography.Text medium size={rpx(15)} color={aiColors.foreground}>
        看板上还没有图表
      </Typography.Text>
      <Typography.Text
        size={rpx(13)}
        color={aiColors.mutedForeground}
        style={{ textAlign: 'center' }}
      >
        在 AI 对话里问一个数据问题，把回答里的图表加到这个看板。
      </Typography.Text>
      {action}
    </BiSurfaceCard>
  );
});
